module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/shield-check-b6ff64608e76e920517378cfdf82532e.svg";